import React, { useCallback } from 'react';
import { SimpleForm } from 'react-admin';

const CustomSimpleForm = props => {
  const { onKeyPress } = props;
  const handleKeyPress = useCallback(
    e => {
      if (e.key === 'Enter') {
        e.preventDefault(); // necessary to prevent default SaveButton submit logic
      }
      if (typeof onKeyPress === 'function') onKeyPress(e);
    },
    [onKeyPress]
  );

  return (
    <SimpleForm
      // We override the react-admin simple form and prevent "Enter" keypress
      {...props}
      onKeyPress={handleKeyPress}
    >
      {props.children}
    </SimpleForm>
  );
};

export default CustomSimpleForm;
